import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './FontStyleField.less';

export default function FontStyleField({ availableFonts, element, input: { onChange } }) {
  const { font: elementFont } = element;
  const { mapped: mappedFonts } = availableFonts;
  const availableVariations = mappedFonts.reduce((result, font) => {
    if (font.name === elementFont.font_family) {
      const { variations } = font;
      variations.forEach(variation => result.push(variation));
    }
    return result;
  }, []);
  return (
    <div className="font-style-selection">
      <div className="font-style-variations">
        <ul>
          {availableVariations &&
            availableVariations.length > 0 &&
            availableVariations.map(variation => {
              const isActiveVariation = elementFont.id === variation.id;
              const { fontFamily, fontStyle, fontWeight } = variation;
              return (
                <li
                  key={variation.id}
                  className={`${isActiveVariation ? 'variation__active' : ''}`}
                >
                  {isActiveVariation && <i className="zolaicon zolaicon-checkmark" />}
                  <span
                    style={{ fontFamily, fontStyle, fontWeight }}
                    onClick={() => onChange(variation)}
                  >
                    {variation.displayName}
                  </span>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}

FontStyleField.propTypes = {
  availableFonts: PropTypes.shape({
    mapped: PropTypes.arrayOf(PropTypes.shape({})),
    raw: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  element: PropTypes.shape({}),
  input: PropTypes.shape({}),
};



// WEBPACK FOOTER //
// ./src/cards/components/Customization/ElementStyleEditor/FontStyleField/FontStyleField.jsx